import React, { Component } from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-toolbox/lib/date_picker';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';

const defaults = {
  period: 'today'
};

class BoxTimingChartSettings extends Component {
  constructor(props) {
    super(props);
    const { from, to } = props.indata;
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata,
        from: from ? new Date(from) : from,
        to: to ? new Date(to) : to
      }
    };
  }

  componentDidMount() {
    this.onChange();
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  setOutdataValues(obj) {
    this.setState(
      { outdata: { ...this.state.outdata, ...obj } },
      this.onChange
    );
  }

  render() {
    const periods = [
      { value: 'today', label: 'Today' },
      { value: 'yesterday', label: 'Yesterday' },
      { value: 'last_week', label: 'Last week' },
      { value: 'last_month', label: 'Last month' },
      { value: 'fixed_date', label: 'Fixed date' }
    ];
    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
        <Dropdown
          onChange={val =>
            this.setOutdataValues({ period: val, from: null, to: null })
          }
          source={periods}
          value={this.state.outdata.period}
          label="Period"
        />
        {this.state.outdata.period === 'fixed_date' && (
          <div>
            <div className="pullLeft" style={{ width: '50%' }}>
              <DatePicker
                label="From"
                locale="us"
                sundayFirstDayOfWeek
                onChange={from => {
                  this.setOutdataValue('from', from);
                }}
                value={this.state.outdata.from}
              />
            </div>
            <div className="pullRight" style={{ width: '50%' }}>
              <DatePicker
                label="To"
                locale="us"
                sundayFirstDayOfWeek
                onChange={to => {
                  this.setOutdataValue('to', to);
                }}
                value={this.state.outdata.to}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, null, null, { pure: false })(
  BoxTimingChartSettings
);



// WEBPACK FOOTER //
// ./app/widgets.new/BoxTimingChart/settings.js